const MS_PER_DAY = 24 * 60 * 60 * 1000;

/** Converts a number of days to milliseconds (1 day = 24 h, arithmetic). */
export function daysToMilliseconds(days: number): number {
  return days * MS_PER_DAY;
}
